(function () {
    const defaultFallback = "[error]";

    class DatatablesRenderer {
        /**
         * attempt to "safe-render": don't return undefined as datatables gives
         * a rather opaque alert -- instead, try to get more info at the console
         * and return something that can be rendered.
         * @param fn
         * @param fallback
         */
        safeRender(fn, fallback) {
            if (fallback === undefined) {
                fallback = defaultFallback;
            }
            return function (data, type, full) {
                try {
                    const
                        result = fn(data, type, full),
                        finalResult = typeof (result) === "function"
                            ? result()
                            : result;
                    if (finalResult === undefined) {
                        const e = new Error();
                        console.error("Renderer returns undefined", data, type, full, e.stack);
                        return fallback;
                    }
                    return result;
                } catch (e) {
                    console.error("error whilst attempting to render column", e, data, type, full);
                    return fallback;
                }
            }
        }
    }
    // FIXME: when campaigntemplatelistinghelper is converted to a service, remove this
    window.Dashboard = Dashboard || {};
    window.Dashboard.CampaignDesigner = Dashboard.CampaignDesigner || {};
    window.Dashboard.CampaignDesigner.safeRender = DatatablesRenderer.prototype.safeRender;

    angular
        .module("dashboard")
        .service("DataTablesRenderer", [
            DatatablesRenderer
        ]);
})();
